import { useAuthStore } from '../store';

export const useRespondAuthChallegeVariables = () => {
  const loginAuthChallenge = useAuthStore((s) => s.authChallengeState);
  const verificationCodeDestination =
    loginAuthChallenge?.ChallengeParameters?.CODE_DELIVERY_DESTINATION;
  const username = loginAuthChallenge?.ChallengeParameters?.USER_ID_FOR_SRP;
  const session = loginAuthChallenge?.Session;

  return {
    verificationCodeDestination,
    username,
    session,
  };
};
